export const environment = {
    production: false,
    baseServerUrl: 'https://circle.thepracticalit.com:3005/v1/'
};
